import $ from 'jquery';


class ConsentForm {
    constructor(elem, opts, api) {
        this.api = api;
        this.opts = $.extend({
            defaultAcceptAll: true,
            inlineAutoConfirm: true,
        }, opts || {});

        let $elem = $(elem);
        if ($elem.hasClass('dsgvo-consent')) {
            this.$elem = $elem;
        } else {
            this.$elem = $elem.find('.dsgvo-consent');
        }
        this.isInline = !!this.$elem.hasClass('dsgvo-consent--inline');
        this._wasOpened = this.isInline;  // is automatically opened, so treated as "was opened" from beginning.

        this.$settings = $('.dsgvo-consent__settings', this.$elem);
        this.$settingsButton = $('.dsgvo-button__link--settings', this.$elem);
        this.$decline = $('.dsgvo-button__link--decline', this.$elem);
        this.$confirm = $('.dsgvo-button__link--confirm', this.$elem);
        this.initialize();
    }

    initialize() {
        // register consent changes to update checkboxes.
        let $toggleAbleCheckboxes = $('.dsgvo-category__checkbox-wrap:not(.dsgvo-category__checkbox-wrap--disabled) .dsgvo-category__checkbox');
        $toggleAbleCheckboxes.each((i, elem) => {
            this.api.on(`enable:${elem.value}`, _ => {
                elem.checked = true;
            });
            this.api.on(`disable:${elem.value}`, _ => {
                elem.checked = false;
            });
        });

        this.$settingsButton.on("click", ev => {
            let className = 'dsgvo-consent__settings--open';
            ev.preventDefault();
            if (this.$settings.hasClass(className)) {
                this.closeSettings(className);
            } else {
                this.openSettings(className);
            }
        });

        this.$decline.on("click", ev => {
            ev.preventDefault();
            this.api.confirm(this.getCheckedIdentifiers(true));
            this.closePopupIfNotInline();
        });

        this.$confirm.on("click", ev => {
            ev.preventDefault();
            this.api.confirm(this.getCheckedIdentifiers());
            this.closePopupIfNotInline();
        });

        window.setTimeout(() => {
            this.$elem.addClass('dsgvo-consent--fade-in');
        });

        if (this.isInline && this.opts.inlineAutoConfirm) {
            // changes happen on checkbox toggle
            $toggleAbleCheckboxes.on('change', ev => {
                if (ev.currentTarget.checked) {
                    this.api.enable($(ev.currentTarget).val(), true)
                } else {
                    this.api.disable($(ev.currentTarget).val(), true)
                }
            });
        }
    }

    /**
     * @param className {String}
     */
    openSettings(className) {
        this._wasOpened = true;
        this.$settings.addClass(className);
        this.$settingsButton.text(this.$settingsButton.attr('data-title-close'));
        this.$confirm.text(this.$confirm.attr('data-title-confirm'));
    }

    /**
     * @param className {String}
     */
    closeSettings(className) {
        this.$settings.removeClass(className);
        this.$settingsButton.text(this.$settingsButton.attr('data-title-open'));
        if (!this.opts.defaultAcceptAll) {
            this.$confirm.text(this.$confirm.attr('data-title-accept'));
        }
    }

    /**
     * @param {Boolean} [requiredOnly]
     * @return {String[]}
     */
    getCheckedIdentifiers(requiredOnly) {
        let identifiers = [];
        /** @type {JQuery<HTMLInputElement>} */
        var $checkboxes;
        if (requiredOnly === true) {
            $checkboxes = $('.dsgvo-category__checkbox-wrap--default .dsgvo-category__checkbox', this.$elem);
        } else {
            $checkboxes = $('.dsgvo-category__checkbox', this.$elem);
        }
        $checkboxes.each((i, checkbox) => {
            // should be added if either checked
            // *or* "defaultAccepAll" is enabled and the settings where not opened yet.
            if (checkbox.checked || (this.opts.defaultAcceptAll && !this._wasOpened)) {
                identifiers.push(($(checkbox).val() || '').trim());
            }
        });
        return identifiers;
    }

    closePopupIfNotInline() {
        if (!this.isInline) {
            this.closePopup();
        }
    }

    closePopup() {
        if (!this.opts.inline) {
            this.$elem.removeClass('dsgvo-consent--fade-in');
            this.$elem.addClass('dsgvo-consent--fade-out');
            window.setTimeout(() => {
                this.$elem.remove();
            }, 500);
        }
    }
}

export default ConsentForm;
